import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FunctionalLoader } from 'seagull';
import { Page } from 'seagull';
import { routes } from "../../constants";
import { useStore, useStoreActions } from "../../contexts";
import ImportWizard from "../../components/ImportWizard/ImportWizard";
import { parseAndValidateContactsCsv } from "./parseAndValidateContactsCsv";
import { ErrorResponse } from "../../infra/ErrorResponse";
import { getSaveContactErrorMessage } from "../../business-logic/contactsLogic";
import { NewContactModel } from "../../models/ContactModel";
export const csvTemplateUrl = 'https://storage.googleapis.com/anchor-statics/Anchor_Import_Contacts-2023-09-20.zip';
const title = 'Import Contacts';
const entityName = 'contacts';
export default function ImportContacts() {
  const {
    data,
    loading,
    error
  } = useStore(state => state.contacts);
  const {
    fetchContacts,
    logBI,
    api
  } = useStoreActions();
  const history = useHistory();
  const [currentSaveData, setCurrentSaveData] = useState();
  const gotoContacts = () => history.push(routes.contacts);
  useEffect(() => {
    document.title = title;
    fetchContacts();
  }, []);
  if (error) {
    throw error;
  }
  return /*#__PURE__*/React.createElement(Page, {
    header: title,
    subheader: "Import your existing contacts in bulk in a few simple steps.",
    "data-testid": "import-contacts",
    loading: loading,
    onClickBack: gotoContacts
  }, /*#__PURE__*/React.createElement(FunctionalLoader, {
    show: !data
  }), /*#__PURE__*/React.createElement(ImportWizard, {
    entityName: entityName,
    saveEntityName: entityName,
    importBtnText: "Import contacts",
    csvTemplateUrl: csvTemplateUrl,
    currentSaveData: currentSaveData,
    testid: "import-contacts",
    parseAndValidateCsv: csvData => parseAndValidateContactsCsv(csvData, data),
    onStartSave: () => {
      setCurrentSaveData(undefined);
      return Promise.resolve();
    },
    saveItem: (contact, idx, contacts) => api.contact.create(NewContactModel.make(contact)).catch(err => {
      const msg = getSaveContactErrorMessage(new ErrorResponse(err));
      setCurrentSaveData({
        entity: entityName,
        saved: idx,
        total: contacts.length,
        errorMsg: msg
      });
      throw err;
    }),
    onEvent: (name, payload) => {
      if (name === 'csvTemplateDownload') {
        logBI(12150);
      } else if (name === 'csvUploaded') {
        logBI(12151, {
          numErrors: payload.badCsv ? 1 : payload.errors.length,
          numRows: payload.items.length
        });
      } else if (name === 'redirectToItems') {
        gotoContacts();
      } else if (name === 'afterSaveFailure') {
        logBI(12152, {
          success: false
        });
      } else if (name === 'afterSaveSuccess') {
        logBI(12152, {
          success: true
        });
      }
    }
  }));
}